import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Soins from "../components/Soins";
import Tarifs from "../components/Tarifs";
import Products from "../components/Products";
import PracticalInfo from "../components/PracticalInfo";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="bg-cream">
      <Navbar />
      <Hero />
      <About />
      <Soins />
      <Tarifs />
      <Products />
      <PracticalInfo />
      <Footer />
    </div>
  );
};

export default Home;
